/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The SourceOperation model module.
 * @module model/SourceOperation
 * @version v0
 */
export default class SourceOperation {
  /**
   * Constructs a new <code>SourceOperation</code>.
   * @alias module:model/SourceOperation
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>SourceOperation</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SourceOperation} obj Optional instance to populate.
   * @return {module:model/SourceOperation} The populated <code>SourceOperation</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new SourceOperation();
      if (data.hasOwnProperty('filename'))
        obj.filename = ApiClient.convertToType(data['filename'], 'String');
      if (data.hasOwnProperty('timestamp'))
        obj.timestamp = ApiClient.convertToType(data['timestamp'], 'Number');
      if (data.hasOwnProperty('numberOfRecords'))
        obj.numberOfRecords = ApiClient.convertToType(data['numberOfRecords'], 'Number');
      if (data.hasOwnProperty('snapshotId'))
        obj.snapshotId = ApiClient.convertToType(data['snapshotId'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} filename
 */
SourceOperation.prototype.filename = undefined;

/**
 * @member {Number} timestamp
 */
SourceOperation.prototype.timestamp = undefined;

/**
 * @member {Number} numberOfRecords
 */
SourceOperation.prototype.numberOfRecords = undefined;

/**
 * @member {String} snapshotId
 */
SourceOperation.prototype.snapshotId = undefined;

